export { default as WhatsAppIcon } from './WhatsAppIcon';
